import { useNavigate } from 'react-router-dom'
import { useLogout } from '../lib/api'
import { useAdminAuth } from '../lib/auth'

export function AdminSettingsPage() {
  const { user } = useAdminAuth()
  const logout = useLogout()
  const nav = useNavigate()

  return (
    <>
      <header className="page-header">
        <div className="page-header__title-row">
          <h1 className="page-header__title">Settings</h1>
          <span className="page-header__subtitle">Your admin profile and session controls.</span>
        </div>
      </header>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 'var(--space-5)', maxWidth: 640 }}>
        <section style={{ background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)', padding: 'var(--space-5)' }}>
          <h3 style={{ margin: '0 0 var(--space-3)', fontSize: 'var(--text-md)', fontWeight: 'var(--weight-semibold)' }}>Profile</h3>
          <dl style={{ display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: 'var(--space-2)', columnGap: 'var(--space-3)', fontSize: 'var(--text-sm)', margin: 0 }}>
            <dt style={{ color: 'var(--text-secondary)' }}>Display name</dt>
            <dd>{user?.displayName ?? '—'}</dd>
            <dt style={{ color: 'var(--text-secondary)' }}>Email</dt>
            <dd style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)' }}>{user?.email ?? '—'}</dd>
            <dt style={{ color: 'var(--text-secondary)' }}>Role</dt>
            <dd><span className="admin-pill admin-pill--info">{user?.role ?? '—'}</span></dd>
            <dt style={{ color: 'var(--text-secondary)' }}>Locale</dt>
            <dd>{user?.locale ?? '—'}</dd>
          </dl>
        </section>

        <section style={{ background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)', padding: 'var(--space-5)' }}>
          <h3 style={{ margin: '0 0 var(--space-3)', fontSize: 'var(--text-md)', fontWeight: 'var(--weight-semibold)' }}>Session</h3>
          <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-sm)', margin: '0 0 var(--space-3)' }}>
            End this admin session. You will return to the sign-in screen.
          </p>
          <button
            type="button"
            className="btn btn--danger"
            disabled={logout.isPending}
            onClick={() => logout.mutate(undefined, { onSuccess: () => nav('/login') })}
          >
            {logout.isPending ? 'Signing out…' : 'Sign out'}
          </button>
        </section>
      </div>
    </>
  )
}
